module.exports = __webpack_public_path__ + "img/icon1-4.670768f1.png";